import React, { useState } from 'react';

const FeatureCard = ({ title, description, onHover }) => {
  return (
    <div 
      className="bg-white p-6 rounded-lg shadow-md transition-all duration-300 ease-in-out"
      onMouseEnter={() => onHover(title)} // Call onHover with the title
    >
      <h4 className="text-xl font-bold text-indigo-900 mb-2">{title}</h4>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

const WhyChooseVirginVoyages = () => {
  const [activeFeature, setActiveFeature] = useState('Unique Venues');

  const features = [
    {
      title: "Unique Venues",
      description: "Discover an array of stunning spaces aboard our ships, from intimate lounges to breathtaking outdoor decks, each offering a distinctive atmosphere for your perfect vacation moments.",
      image: "/RedRoom.webp"
    },
    {
      title: "Exciting Activities",
      description: "Join fellow sailors in an incredible range of activities designed for fun and adventure, creating unforgettable memories while sailing across beautiful ocean horizons.",
      image: "/Groupie.avif"
    },
    {
      title: "Culinary Delights",
      description: "Savor extraordinary dining experiences with diverse cuisines crafted by world-class chefs, making every meal aboard an adventure for your taste buds.",
      image: "/ExtraVirgin.avif"
    },
    {
      title: "Luxury Amenities",
      description: "Indulge in our premium amenities, from rejuvenating spas to state-of-the-art fitness centers and spectacular entertainment venues that make your voyage truly extraordinary.",
      image: "/Boxing.avif"
    }
  ];

  return (
    <section className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Why Sail with <span className="text-indigo-600">Virgin Voyages</span>?
          </h2>
          <p className="mt-4 text-xl text-gray-600">
            Experience a revolutionary approach to cruising, where luxury meets adventure on the high seas.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Unparalleled Experience at Sea
              </h3>
              <p className="text-gray-600 mb-6">
                Sailing with Virgin Voyages means embarking on an unforgettable journey filled with luxury amenities, breathtaking views, and exceptional service at every turn.
              </p>
            </div>
            <div className="relative pb-[100%] md:pb-0 h-[400px]">
              <img
                src={features.find(f => f.title === activeFeature).image}
                alt={activeFeature}
                className="rounded-lg shadow-xl w-full h-full object-cover transition-opacity duration-300 ease-in-out"
              />
            </div>
          </div>

          <div className="space-y-8 mt-16 md:mt-0">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Personalized Sailing Experience
              </h3>
              <p className="text-gray-600 mb-6">
                Our dedicated crew ensures your voyage is tailored to your desires, creating the perfect balance of relaxation and adventure for an unforgettable experience at sea.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-6">
              {features.map((feature) => (
                <FeatureCard
                  key={feature.title}
                  title={feature.title}
                  description={feature.description}
                  onHover={setActiveFeature}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 flex justify-center space-x-2">
          {[...Array(6)].map((_, index) => (
            <div
              key={index}
              className="w-2 h-2 rounded-full bg-indigo-500"
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseVirginVoyages;
